var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radio-field-wrapper"},[_vm._t("field-label"),_c('v-switch',{model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }